export const NoContactInstructions = "[NO CONTACT DELIVERY - LEAVE AT DOOR/DOORMAN] ";
